import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover, PopoverBody, PopoverCloseButton, PopoverFooter, PopoverHeader } from 'foundations-components/transitional/components/Popover';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ScreenReaderAnnouncer } from 'marketplace-ui-common/components/accessibility/ScreenReaderAnnouncer';
import { Fragment, useCallback, useState } from 'react';
import { ReviewContextProvider, useReviewContext } from './context/ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewPopover({
  bodyContent,
  children,
  customValidationErrors,
  defaultReview,
  headerContent,
  onChange,
  onClose,
  onSubmit,
  popoverProps,
  showLegalCheckbox = false,
  submitButtonText,
  validationSchema
}) {
  return /*#__PURE__*/_jsx(ReviewContextProvider, {
    customValidationErrors: customValidationErrors,
    defaultReview: defaultReview,
    onChange: onChange,
    validationSchema: validationSchema,
    children: /*#__PURE__*/_jsx(Popover, Object.assign({}, popoverProps, {
      content: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(PopoverHeader, {
          children: [headerContent, /*#__PURE__*/_jsx(PopoverCloseButton, {
            popoverUse: "default",
            onClick: onClose
          })]
        }), /*#__PURE__*/_jsx(PopoverBody, {
          children: bodyContent
        }), /*#__PURE__*/_jsx(PopoverFooter, {
          marginBlockStart: "200",
          children: /*#__PURE__*/_jsx(FooterContent, {
            onClose: onClose,
            onSubmit: onSubmit,
            showLegalCheckbox: showLegalCheckbox,
            submitButtonText: submitButtonText
          })
        })]
      }),
      children: children
    }))
  });
}
function FooterContent({
  onClose,
  onSubmit,
  showLegalCheckbox,
  submitButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "trellisEcosystem.reviews.submit"
  })
}) {
  const {
    customValidationErrors,
    review,
    validationErrors
  } = useReviewContext();
  const [checkedLegalDisclaimer, setCheckedLegalDisclaimer] = useState(false);
  const [showLegalTooltip, setShowLegalTooltip] = useState(false);
  const handleSubmitClick = useCallback(() => {
    if (showLegalCheckbox && !checkedLegalDisclaimer) {
      setShowLegalTooltip(true);
    } else {
      onSubmit(review);
    }
  }, [checkedLegalDisclaimer, onSubmit, review, showLegalCheckbox]);
  const submitDisabled = validationErrors.length > 0 || customValidationErrors.length > 0;
  const renderedButtons = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: customValidationErrors[0],
      children: /*#__PURE__*/_jsx(Button, {
        disabled: submitDisabled,
        onClick: handleSubmitClick,
        use: "primary",
        children: submitButtonText
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onClose,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trellisEcosystem.reviews.cancel"
      })
    })]
  });
  if (!showLegalCheckbox) {
    return renderedButtons;
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ScreenReaderAnnouncer, {
      announcedText: showLegalTooltip ? unescapedText('trellisEcosystem.reviews.legalTooltip') : '',
      use: "assertive"
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "500",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        flexDirection: "row",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          open: showLegalTooltip,
          title: unescapedText('trellisEcosystem.reviews.legalTooltip'),
          children: /*#__PURE__*/_jsx(Checkbox, {
            "aria-labelledby": "disclaimer-text",
            checked: checkedLegalDisclaimer,
            marginBlockStart: "100",
            onChange: ({
              target: {
                checked
              }
            }) => {
              setShowLegalTooltip(false);
              setCheckedLegalDisclaimer(checked);
            }
          })
        }), /*#__PURE__*/_jsx(View, {
          as: "span",
          id: "disclaimer-text",
          marginInlineStart: "200",
          minInlineSize: "0",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            elements: {
              Link
            },
            message: "trellisEcosystem.reviews.legal_jsx",
            options: {
              external: true,
              href: 'https://legal.hubspot.com/review-guidelines'
            }
          })
        })]
      }), renderedButtons]
    })]
  });
}